// extracted by mini-css-extract-plugin
export default {"box":"styles_box__keW1c","box_icon":"styles_box_icon__maiSY"};